import { useCallback, useLayoutEffect, useRef, useState } from 'react';
import styles from '@/modules/articles/components/scrollers/bullet-list/line-clamp.module.scss';
import { MediaMeasureProvider } from '@/modules/articles/contexts/media-measure-context';

const DEFAULT_BG_COLOR = 'rgba(0, 0, 0, 0)';

export default function LineClamp({
  children,
  lines,
}: {
  children: React.ReactNode;
  lines: number;
}) {
  const fullTextSizeRef = useRef<number>(0);
  const clampedTextSizeRef = useRef<number>(0);
  const fullTextRef = useRef<HTMLDivElement>(null);
  const clampedTextRef = useRef<HTMLDivElement>(null);

  const [bgColor, setBgColor] = useState<string>('red');
  const [showMore, setShowMore] = useState<boolean>(false);
  const [expanded, setExpanded] = useState<boolean>(false);

  useLayoutEffect(() => {
    fullTextSizeRef.current = fullTextRef.current?.clientHeight || 0;
    clampedTextSizeRef.current = clampedTextRef.current?.clientHeight || 0;
    if (fullTextSizeRef.current > clampedTextSizeRef.current) {
      let element = fullTextRef.current as HTMLElement;
      let bgColor = DEFAULT_BG_COLOR;
      while (bgColor === DEFAULT_BG_COLOR) {
        bgColor = getComputedStyle(element).backgroundColor;
        if (bgColor !== DEFAULT_BG_COLOR) {
          break;
        }
        if (element.parentElement) {
          element = element.parentElement as HTMLElement;
        } else {
          break;
        }
      }
      setShowMore(true);
      setBgColor(bgColor);
    } else {
      setShowMore(false);
    }
  }, []);

  const toggleExpanded = useCallback((event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setExpanded(expanded => !expanded);
  }, []);

  return (
    <div>
      <div className={styles.hidden} ref={fullTextRef}>
        <MediaMeasureProvider value={true}>{children}</MediaMeasureProvider>
      </div>
      <div
        className={styles.hidden + ' ' + styles.clamped}
        // @ts-ignore
        style={{ '--line-clamp': lines }}
        ref={clampedTextRef}
      >
        <MediaMeasureProvider value={true}>{children}</MediaMeasureProvider>
      </div>
      <div
        className={styles.content + ' ' + (showMore && !expanded ? styles.clamped : '')}
        // @ts-ignore
        style={{ '--line-clamp': lines }}
      >
        <div
          className={showMore && !expanded ? styles.faded : ''}
          // @ts-ignore
          style={{ '--bg-color': bgColor }}
        >
          {children}
        </div>
        <div
          className={`bg-body-secondary d-inline-block ${showMore && !expanded ? styles.toggleExpanded : ' '}`}
        >
          {showMore && !expanded && (
            <a href={'#a'} onClick={toggleExpanded}>
              More...
            </a>
          )}
          {showMore && expanded && (
            <a href={'#a'} onClick={toggleExpanded}>
              Less...
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
